import './QuotationTable.scss';
import { Table, Card, Empty, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import InputComponent from '../../common/InputComponent/InputComponent';
import SelectComponent from '../../common/SelectComponent/SelectComponent';
import { useSelector } from 'react-redux';
import ButtonIconSolidLarge from '../../common/ButtonIconSolid/ButtonIconSolidLarge';
import { Icon } from '../../icon/icon';
import ButtonSecondaryMedium from '../../common/ButtonSecondary/ButtonSecondaryMedium';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const { Column, ColumnGroup, Summary } = Table;

const QuotationTablePDF = ({ data = [], form }) => {
  const { t } = useTranslation();
  const { productNames, suppliers, materialTypes, materialDescription } =
    useSelector(state => state.quotation);
  const getValue = field => {
    const value = form.getFieldValue(field);
    return value ? value : '';
  };
  return (
    <Card className="quotation-table bg-fills-white border-none rounded-lg">
      <Table
        dataSource={data}
        rowKey="id"
        locale={{
          emptyText: (
            <Empty
              description={t(
                'quotation.table.noData',
                'Hãy bắt đầu thêm sản phẩm vào bảng báo giá của bạn'
              )}
              className="p-16"
            />
          ),
        }}
        bordered
        pagination={false}
        summary={pageData => {
          const total = pageData.reduce((sum, record) => {
            const recordTotal = Number(record.total ?? 0);
            return sum + (isNaN(recordTotal) ? 0 : recordTotal);
          }, 0);
          return (
            <Summary.Row>
              <Summary.Cell
                index={0}
                colSpan={10}
                align="left"
                className="text-title-small-emphasized bg-fills-primary-varient"
              >
                {t('quotation.table.total', 'Tổng cộng')}
              </Summary.Cell>
              <Summary.Cell index={10} colSpan={3} align="left">
                <span className="font-medium">
                  {convertForeignCurrency(total)}
                </span>
              </Summary.Cell>
            </Summary.Row>
          );
        }}
      >
        <Column
          title={t('quotation.table.product_name', 'Tên Sản Phẩm')}
          dataIndex={'product_name'}
          key={'product_name'}
          width={300}
          align={'center'}
          render={(_, record) => (
            <div className="flex px-12 py-8">
              <p className="flex flex-col gap-8 items-center">
                <span className="text-body-large font-normal min-h-40">
                  {getValue([record.key, 'product_name'])}
                </span>
              </p>
              {/* <Form.Item
                name={[record.key, 'productName']}
                className="w-[250px]"
              >
                <SelectComponent
                  options={[
                    ...productNames.data?.map(item => ({
                      label: item,
                      value: item,
                    })),
                  ]}
                  showSearch
                  placeholder={t(
                    'quotation.table.selectProduct',
                    'Chọn sản phẩm'
                  )}
                  allowClear={true}
                  className="w-full"
                />
              </Form.Item> */}
            </div>
          )}
        />
        <Column
          title={t('quotation.table.group', 'Nhóm')}
          dataIndex={'group'}
          key={'group'}
          width={180}
          minWidth={180}
          align={'center'}
          render={(_, record) => (
            <div className="flex px-12 py-8">
              <p className="flex flex-col gap-8 items-center">
                <span className="text-body-large font-normal min-h-40">
                  {getValue([record.key, 'groups'])}
                </span>
              </p>
              {/* <Form.Item name={[record.key, 'group']} className="w-[154px]">
                <SelectComponent
                  options={[
                    ...(group?.[record.key]?.data?.map(item => ({
                      label: item,
                      value: item,
                      className:
                        'max-w-[300px] md:max-w-[600px] lg:max-w-full [&_.ant-select-item-option-content]:whitespace-normal',
                    })) ?? []),
                  ]}
                  disabled={group?.[record.key]?.isLoading}
                  showSearch
                  placeholder={t('quotation.table.selectGroup', 'Chọn nhóm')}
                  allowClear={true}
                  className="w-full"
                />
              </Form.Item> */}
            </div>
          )}
        />
        <Column
          title={t('quotation.table.material_type', 'Loại ván')}
          dataIndex={'material_type'}
          key={'material_type'}
          width={200}
          align={'center'}
          render={(_, record) => (
            <div className="flex px-12 py-8">
              <p className="flex flex-col gap-8 items-center">
                <span className="text-body-large font-normal min-h-40">
                  {getValue([record.key, 'material_type'])}
                </span>
              </p>
              {/* <Form.Item
                name={[record.key, 'materialType']}
                className="w-[150px]"
              >
                <SelectComponent
                  options={[
                    ...materialTypes.data?.map(item => ({
                      label: item,
                      value: item,
                    })),
                  ]}
                  showSearch
                  placeholder={t(
                    'quotation.table.selectMaterial',
                    'Chọn loại ván'
                  )}
                  allowClear={true}
                  className="w-full"
                />
              </Form.Item> */}
            </div>
          )}
        />
        <Column
          title={t('quotation.table.material_description', 'Mô Tả Chất liệu')}
          dataIndex={'material_description'}
          key={'material_description'}
          width={200}
          align={'center'}
          render={(_, record) => (
            <div className="flex px-12 py-8">
              <p className="flex flex-col gap-8 items-center">
                <span className="text-body-large font-normal min-h-40">
                  {getValue([record.key, 'material_description'])}
                </span>
              </p>
              {/* <Form.Item
                name={[record.key, 'material_description']}
                className="w-[150px]"
              >
                <SelectComponent
                  options={[
                    ...materialDescription.data?.map(item => ({
                      label: item,
                      value: item,
                    })),
                  ]}
                  showSearch
                  placeholder={t(
                    'quotation.table.selectDescription',
                    'Chọn mô tả chất liệu'
                  )}
                  allowClear={true}
                  className="w-full"
                />
              </Form.Item>
              */}
            </div>
          )}
        />
        <Column
          title={t('quotation.table.unit', 'Đơn Vị Tính')}
          dataIndex={'unit'}
          key={'unit'}
          width={80}
          align={'center'}
          render={text => (
            <div className="flex px-12 py-8">
              <span className="text-body-large font-normal min-h-40">
                {text}
              </span>
            </div>
          )}
        />
        <ColumnGroup
          title={t('quotation.table.size', 'Kích thước(mm)')}
          dataIndex={'size'}
          key={'size'}
          width={240}
          align={'center'}
        >
          <Column
            title={t('quotation.table.length', 'Dài')}
            dataIndex={['size', 'length']}
            key={['size', 'length']}
            width={80}
            align={'center'}
            render={(text, record) => {
              return (
                <div className="flex px-12 py-8">
                  <p className="flex flex-col gap-8 items-center">
                    <span className="text-body-large font-normal min-h-40">
                      {getValue([record.key, 'size', 'length'])}
                    </span>
                  </p>
                </div>
              );
            }}
          />
          <Column
            title={t('quotation.table.height', 'Cao')}
            dataIndex={['size', 'height']}
            key={['size', 'height']}
            width={80}
            align={'center'}
            render={(text, record) => {
              return (
                <div className="flex px-12 py-8">
                  <p className="flex flex-col gap-8 items-center">
                    <span className="text-body-large font-normal min-h-40">
                      {getValue([record.key, 'size', 'height'])}
                    </span>
                  </p>
                </div>
              );
            }}
          />
          <Column
            title={t('quotation.table.depth', 'Sâu')}
            dataIndex={['size', 'depth']}
            key={['size', 'depth']}
            width={80}
            align={'center'}
            render={(text, record) => {
              return (
                <div className="flex px-12 py-8">
                  <p className="flex flex-col gap-8 items-center">
                    <span className="text-body-large font-normal min-h-40">
                      {getValue([record.key, 'size', 'depth'])}
                    </span>
                  </p>
                </div>
              );
            }}
          />
        </ColumnGroup>
        <Column
          title={t(
            'quotation.table.quantity_formula',
            'Cách Tính Khối Lượng Hạng Mục'
          )}
          dataIndex={'quantity_formula'}
          key={'quantity_formula'}
          width={200}
          align={'center'}
          render={text => (
            <div className="flex px-12 py-8">
              <span className="text-body-large font-normal min-h-40">
                {text}
              </span>
            </div>
          )}
        />
        <Column
          title={t('quotation.table.price', 'Đơn Giá')}
          dataIndex={'price'}
          key={'price'}
          width={100}
          align={'center'}
          render={text =>
            text && (
              <div className="flex px-12 py-8">
                <span className="text-body-large font-normal min-h-40">
                  {convertForeignCurrency(Number(text))}
                </span>
              </div>
            )
          }
        />
        <Column
          title={t('quotation.table.quantity', 'Khối Lượng')}
          dataIndex={'quantity'}
          key={'quantity'}
          width={100}
          align={'center'}
          render={text => (
            <div className="flex px-12 py-8">
              <span className="text-body-large font-normal min-h-40">
                {text}
              </span>
            </div>
          )}
        />
        <Column
          title={t('quotation.table.price', 'Thành tiền')}
          dataIndex={'total'}
          key={'total'}
          width={100}
          align={'center'}
          render={text =>
            text && (
              <div className="flex px-12 py-8">
                <span className="text-body-large font-normal min-h-40">
                  {convertForeignCurrency(Number(text ?? 0))}
                </span>
              </div>
            )
          }
        />

        {/* <Column
          title={t('quotation.table.image', 'Hình ảnh tham khảo')}
          dataIndex={'image'}
          key={'image'}
          width={200}
          align={'center'}
          render={text => <span className="font-medium">{text}</span>}
        /> */}
        <Column
          title={t('quotation.table.description', 'Ghi chú')}
          dataIndex={'description'}
          key={'description'}
          align={'center'}
          render={text => <span className="font-medium">{text}</span>}
        />
      </Table>
    </Card>
  );
};

export default QuotationTablePDF;
